/* loaded by smart-asset */
export default require("./login-artwork-right~vJuAPjhF.svg")